























































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import UnsafeChange from '@/components/economy/settings/accounting-integration/UnsafeChange.vue'

@Component({
  components: {
    UnsafeChange,
  },
})
export default class Invoices extends Vue {
  @Prop()
  private integration

  @Prop()
  private features

  @Prop()
  private showUnsupportedFeatures

  private isFeatureSupported(feature: string): boolean {
    return this.features.isSupported(this.integration?.type, feature)
  }

  private isFeatureVisible(feature: string): boolean {
    return this.showUnsupportedFeatures || this.isFeatureSupported(feature)
  }

  private featureLabel(label: string, feature: string): string {
    label = this.$t(label)
    if (!this.isFeatureSupported(feature)) {
      const notSupportedText = this.$t('NOT SUPPORTED by %s integration')
      label += ' - ' + notSupportedText.replace('%s', this.integration.type)
    }
    return label
  }
}
